import qs from 'qs'
import { useUserStore } from '@/store'
import { platform } from '@/utils/platform'
import { getEvnBaiDuBaseUrl, getEvnBaseUrl } from '@/utils'

export type CustomRequestOptions = UniApp.RequestOptions & {
  query?: Record<string, any>
  /** 出错时是否隐藏错误提示 */
  hideErrorToast?: boolean
} & IUniUploadFileOptions // 添加uni.uploadFile参数类型

// 请求基准地址
const baseUrl = getEvnBaseUrl()

// 请求基准地址
const baiDuBaseUrl = getEvnBaiDuBaseUrl()

// 拦截器配置
const httpInterceptor = {
  // 拦截前触发
  invoke(options: CustomRequestOptions) {
    // 接口请求支持通过 query 参数配置 queryString
    if (options.query) {
      const queryStr = qs.stringify(options.query)
      if (options.url.includes('?')) {
        options.url += `&${queryStr}`
      } else {
        options.url += `?${queryStr}`
      }
    }
    if (options.url.includes('baidu')) {
      // 请求基准地址
      options.url = baiDuBaseUrl + options.url.split('baidu')[1]
    } else if (options.url.includes('aliyuncs')) {
      options.url = options.url + ''
    } else {
      options.url = baseUrl + options.url
    }
    // TIPS: 如果需要对接多个后端服务，也可以在这里处理，拼接成所需要的地址
    // 1. 请求超时
    options.timeout = 100000
    // 2. （可选）添加小程序端请求头标识
    options.header = {
      ...options.header,
      platform: 'WX',
      version: '1.0.1',
    }
    // 3. 添加 token 请求头标识
    const userStore = useUserStore()
    if (userStore.accessToken) {
      options.header.Authorization = `Bearer ${userStore.accessToken}`
    }
  },
}

export const requestInterceptor = {
  install() {
    // 拦截 request 请求
    uni.addInterceptor('request', httpInterceptor)
    // 拦截 uploadFile 文件上传
    uni.addInterceptor('uploadFile', httpInterceptor)
  },
}
